import { useCallback } from 'react';
import { useDispatch, showNotification } from '../state';

export function useNotify() {
  const dispatch = useDispatch();
  const cb = useCallback(
    (
      message: string,
      variant: 'success' | 'error' | 'warning' | 'info' = 'success',
      duration?: number,
    ) => {
      dispatch(
        showNotification({
          message,
          variant,
          duration,
        }),
      );
    },
    [dispatch],
  );
  return cb;
}
